const pad = (value: number, size = 2) => String(value).padStart(size, '0');

export const formatDayBR = (date: Date | null): string => (date
  ? `${pad(date.getDate())}/${pad(date.getMonth() + 1)}/${pad(date.getFullYear(), 4)}`
  : '');

export const formatMonthBR = (date: Date | null): string => (date
  ? `${pad(date.getMonth() + 1)}/${pad(date.getFullYear(), 4)}`
  : '');

const MIN_YEAR = 1900;
const MAX_YEAR = 2100;

export const parseDayBR = (text: string): Date | null => {
  const match = /^(\d{2})\/(\d{2})\/(\d{4})$/.exec(text.trim());
  if (!match) return null;

  const [day, month, year] = [Number(match[1]), Number(match[2]), Number(match[3])];
  if (year < MIN_YEAR || year > MAX_YEAR) return null;

  const date = new Date(year, month - 1, day);
  const valid = date.getFullYear() === year && date.getMonth() === month - 1 && date.getDate() === day;
  return valid ? date : null;
};

export const parseMonthBR = (text: string): Date | null => {
  const match = /^(\d{2})\/(\d{4})$/.exec(text.trim());
  if (!match) return null;

  const [month, year] = [Number(match[1]), Number(match[2])];
  if (month < 1 || month > 12 || year < MIN_YEAR || year > MAX_YEAR) return null;

  return new Date(year, month - 1, 1);
};

export interface DateRangeValue {
  start: Date | null;
  end: Date | null;
}

// A data editada vale; a outra se ajusta para o intervalo continuar coerente.
// Início escolhido sem fim preenche o fim com o mesmo dia. Fim sem início não inventa início.
export const applyRangeEdit = (
  current: DateRangeValue,
  side: 'start' | 'end',
  date: Date | null,
): DateRangeValue => {
  let { start, end } = current;

  if (side === 'start') {
    start = date;
    if (date && (!end || end < date)) end = date;
  } else {
    end = date;
    if (date && start && start > date) start = date;
  }

  return { start, end };
};
